export const ADD_ACTION_NAME = 'Add Gateway';
export const EDIT_ACTION_NAME = 'Save Changes';
export const CANCEL_ACTION_NAME = 'Cancel';
export const ERROR_MESSAGE = 'Please enter all mandatory fields';
export const BREADCRUMBS_ROOT = 'Sites';
export const BREADCRUMBS_GATEWAYS = 'Gateways';
export const BREADCRUMBS_ADDFORM = 'Add Gateway';
export const BREADCRUMBS_EDITFORM = 'Edit Gateway: ';
export const LAST_EDITED_LABEL = 'Last edited on: ';
export const PAYLOAD_INTERVAL_TOOLTIP = 'Expected maximum time between payloads (info only)';
export const GATEWAY_TYPE_TOOLTIP = 'To change gateway type, new gateway needs to be added.';
export const FX_30_GATEWAY_TYPE = 'FX30';
export const EWON_GATEWAY_TYPE = 'Ewon';
export const KALLIPR_GATEWAY_TYPE = 'Kallipr';
export const STREAM_M_LITE_GATEWAY_TYPE = 'StreamMLite';
export const DELETE_LABEL = 'Delete';
export const ALERT_DIALOG_TAG_TYPE_CHANGE_CONTENT =
  'Changing Tag Type will result in the removal of the current Advanced Tag Mapping data.';
export const ALERT_DIALOG_TAG_TYPE_CHANGE_TITLE = 'Change Tag Type';
export const ALERT_DIALOG_CANCEL_BUTTON_LABEL = 'Cancel';
export const ALERT_DIALOG_CONFIRM_BUTTON_LABEL = 'Confirm';

export const SEND_DATA_TO_GATEWAY_TABLE_HEAD = [
  { id: 'site', label: 'Site', align: 'left', testId: 'site-header' },
  {
    id: 'tag',
    label: 'Tag',
    align: 'left',
    testId: 'tag-header',
  },
  { id: 'rawUnit', label: 'Raw Unit', align: 'left', testId: 'raw-unit-header' },
];
